import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import AlumniStats from '../components/AlumniStats';
import AlumniGuiding from '../components/AlumniGuiding'; 

function Alumni() {
  const location = useLocation();

  // Scroll to the section if specified in the URL state
  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        // Use smooth scrolling to the section
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <div className='alumni-page-wrapper'> {/* Wrapper div for structure */}
      <div className='teacherstaff-mainbox'>
        <div className='ibdp-hero-sec'>
          <img src='newimg/studentex.webp' alt="Alumni Banner" />
        </div>
      </div>

      {/* Widgets Section */}
      <div className="widgets-container" style={{ padding: '20px 0' }}>
        <AlumniStats />
   
 
   
 <div className='uni-placement-row'>
  
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Krish-Narang.jpeg'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>KRISH NARANG</h3>
                  <p>Psychology</p>
                  <p>YEAR OF PASSING: 2024</p>
                  <p>COLLEGE: Monash University Malaysia</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Nishu-Phalsawal.png'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>NISHU PHALSWAL</h3>
                  <p>Lieutenant Equivalent</p>
                  <p>YEAR OF PASSING:  2018</p>
                  <p>Army Hospital Research & Referral</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Deepanshu-Verma.png'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Deepanshu Verma</h3>
                  <p>Advocate</p>
                  <p>YEAR OF PASSING: 2018</p>
                  <p>COLLEGE: National Law University Jodhpur Supreme Court of India</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Ishan-Kasliwal.png'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Ishan Kasliwal</h3>
                  <p>Advocate</p>
                  <p>YEAR OF PASSING:  2017</p>
                  <p>Law College, Dehradun</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Bajrang-Singh.png'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Bajrang Singh Shekhawat</h3>
                  <p>Advocate</p>
                  <p>COLLEGE: University of Rajasthan</p>
                  <p>Dilip Singh Rathore & Associates</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Gaurav-Chaplot.jpg.webp'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Gaurav Chaplot</h3>
                  <p>Associate - Public Policy Chase Advisors</p>
                  <p>YEAR OF PASSING:  2018</p>
                  <p>Law</p>
                  <p>National Law University Delhi</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Apoorv-Saxena.png'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>APOORV SAXENA </h3>
                  <p>Regional Sales manager in Neuberg Diagnostics</p>
                  <p>YEAR OF PASSING: 2015 </p>
                  <p>Bio Sciences & Bio Technology</p>
                  <p>Symbiosis Centre for Distance Learning</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Yug-Bhavsar.png'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Yug Bhavsar</h3>
                  <p>Bio Sciences & Bio Technology</p>
                  <p>YEAR OF PASSING: 2024</p>
                  <p>SRM Institute of Science and Technology </p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Arpit-Vijay.png'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Arpit Vijay</h3>
                  <p> Retention Strategy and Growth in Gartner</p>
                  <p>YEAR OF PASSING: 2015 </p>
                  <p>Masters in Design </p>
                  <p>ndian Institute of Management, Kashipur</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Jovis-Jacob.png'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Jovis Jacob</h3>
                  <p> YEAR OF PASSING: 2015</p>
                  <p>Ph.D. Scholar</p>
                  <p>ICMR-National Institute of Nutrition</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Saloni-Sharma.png'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Saloni Sharma</h3>
                  <p> Starbucks Manager</p>
                  <p>YEAR OF PASSING: 2018</p>
                  <p>Oxford Brookes University</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Naman-Agarwal.png'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Naman Agarwal</h3>
                  <p> Senior Associate in JP Morgan Chase & Co. </p>
                  <p> YEAR OF PASSING: 2013  </p>
                  <p>Indian Institute of Management, Lucknow</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Kritika-Gupta.png'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Kritika Gupta</h3>
                  <p> Senior Executive in Swiggy </p>
                  <p> YEAR OF PASSING: 2018 </p>
                  <p>Business Management</p>
                  <p>SVKM's Narsee Monjee Institute of Management Studies (NMIMS)</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Shreyansh-Sharma.png'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Shreyansh Sharma</h3>
                  <p> Business Management </p>
                  <p> YEAR OF PASSING: 2020 </p>
                  <p>The University of Sydney</p>
                </div>
              </div>
  
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Nilkita-Agarwal.jpg'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Nikita Agarwal</h3>
                  <p> Financial Accountant in Deloitte Consulting LLP</p>
                  <p> YEAR OF PASSING: 2019</p>
                  <p>Christ University, Bangalore </p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Lakshay-Pratap-Singh-Shekhawat.webp'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Lakshay Pratap Singh Shekhawat</h3>
                  <p> Les Roches Marbella,Spain</p>
                  <p>(BBA in global hospitality management)</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to=""><img src='../img/placements/university-placement/Kavya-Chandra.webp'></img></Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Kavya Chandra</h3>
                  <p>Bachelor of Science in Forensic Science and Psychology</p>
                  <p>Trent University, Toronto, Canada (4 years)</p>
                  <p>University of Kent, London, UK</p>
                </div>
              </div>
      
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to="">
                  <img src='../img/placements/university-placement/Vaishali-Sharma.webp'></img>
                  </Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Vaishali Sharma</h3>
                  <p>Wichita State University</p>
                  <p>Mechanical Engineering</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to="">
                  <img src='../img/placements/university-placement/Aanya Chandra.webp'></img>
                  </Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Aanya Chandra</h3>
                  <p>Psychology Honours</p>
                  <p>Trent University</p>
                  <p>Ontario, Canada</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to="">
                  <img src='../img/placements/university-placement/Akshita Swaroop.webp'></img>
                  </Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Akshita Swaroop</h3>
                  <p>The Smeal College of Business at The Pennsylvania State University Undergraduate</p>
          
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to="">
                  <img src='../img/placements/university-placement/Tisha Jindal.webp'></img>
                  </Link>
                </div>
                <div className='uni-placement-content'>
                  <h3>Tisha Jindal</h3>
                  <p>Aerospace Engineering</p>
                  <p>Nanyang Technological University</p>
                </div>
              </div>
              <div className='uni-placements'>
                <div className='uni-placemet-img'>
                  <Link to="">
                  <img src='../img/placements/university-placement/Kunal Soni.webp'></img>
                  </Link>
                </div>
                <div className='uni-placement-content'>
                  <h3> Kunal Soni</h3>
                  <p>Bachelor of Economics</p>
                  <p>University of massachusetts Amherst</p>
                </div>
              </div>



        <div className='uni-placements'>
          <div className='uni-placemet-img'>
            <Link to=""><img src='../img/placements/university-acceptance/Ayush-Aggarwal.webp'></img></Link>
          </div>
          <div className='uni-placement-content'>
            <h3>Ayush Aggarwal</h3>
            <p>London School Of Business</p>
            {/* <ol>
              <li>London School Of Business </li>
              <li>Cass business school</li>
              <li>University of leeds</li>
              <li>University of exter</li>
            </ol>
            <p> <b>USA university</b> </p>
            <ol>
              <li>Airzona university</li>
              <li>Indiana University Bloomington France EDHEC Business school</li>
            </ol> */}
          </div>
        </div>
        <div className='uni-placements'>
          <div className='uni-placemet-img'>
            <Link to="">
            <img src='../img/placements/university-acceptance/Sara-Yadav.webp'></img>
            </Link>
          </div>
          <div className='uni-placement-content'>
            <h3>Sara Yadav</h3>
            <p>King’s College London (London, UK)</p>
            {/* <p> University of Manchester (Manchester, UK)</p>
            <p>Queen Mary University (London, UK)</p>
            <p>Royal Holloway University (London, UK)</p>
            <p> University of Reading(Reading, UK)</p>
            <p> Ashoka University (Sonipat, India)</p>
            <p><b>   Under-graduation:</b></p>
            <p>King’s College London (London, UK)</p>
            <p> Course:- English with Film Studies</p> */}

          </div>
        </div>


              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
      <img src='../newimg/alumni/Kumari Rinki.jpeg' />
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>Kumari Rinki</h3>
    <p>Monash University, Clayton Campus, Australia</p>
    <p>Bachelor of science in Psychology</p>
  </div>
</div>
              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
      <img src='../newimg/alumni/Sankalp-Sharma.jpg' />
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>Sankalp Sharma</h3>
    <p>III OFFICER</p>
    <p>YEAR OF PASSING: 2013</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
      <img src='../newimg/alumni/Deeksha-Singh-Shekhawat.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>DEEKSHA SINGH SHEKHAWAT</h3>
    <p>CORPORATE LAWYER WITH HDFC</p>
    <p>YEAR OF PASSING: 2009</p>
    <p>COLLEGE: Army Institute of Law, Mohali.</p>
    <p>COURSE: B.A.LL.B (5 Years Integrated Course)</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
     <img src='../newimg/alumni/Abibsha-Singh-Shekhawat-.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>Abibsha Singh Shekhawat</h3>
    <p>PURSUING M.Sc. FORENSIC SCIENCE</p>
    <p>YEAR OF PASSING: 2016</p>
    <p>COLLEGE: National Forensic Science University, Gandhinagar.</p>
  
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
        <img src='../newimg/alumni/Pranjal-S-Rajawat.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>PRANJAL S RAJAWAT</h3>
    <p>MARKETING MANAGER, 91NINJAS</p>
    <p>YEAR OF PASSING: 2013</p>
    <p>COLLEGE: IndianInstitute Of Management, Lucknow (IIML"20)</p>
    <p>EARLIER EXPERIENCE: Associate Manager, Ab-Inbev</p>
  
  </div>
</div>
  
              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
     <img src='../newimg/alumni/Sanskar-Sharma.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>Sanskar Sharma</h3>
    <p>DECK CADET</p>
    <p>YEAR OF PASSING: 2018</p>

  
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
         <img src='../newimg/alumni/Ankit-Olla.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>ANKIT OLLA</h3>
    <p>FIGHTER PILOT, INDIAN AIRFORCE</p>
    <p>YEAR OF PASSING: 2015</p>

  
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
       <img src='../newimg/alumni/Mandatar-Singh-Tanwar.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>MANDATAR SINGH TANWAR</h3>
    <p>RAJASTHAN POLICE (OUTSTANDING SPORTSPERSON)</p>
    <p>YEAR OF PASSING: 2018</p>
    <p>FIELD CHOSEN: Several Times National Medalist in Equestrian</p>
    

  
  </div>
</div>

              {/* <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
         <img src='../newimg/alumni/Lt-Anant-Vijay-Singh-Shekhawat.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>Lt ANANT VIJAY SINGH SHEKHAWAT</h3>
    <p>INDIAN ARMY, UNIT: 20 MECHANISED INFANTRY</p>
    <p>YEAR OF PASSING: 2013</p>
 

  
  </div>
</div> */}


              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
         <img src='../newimg/alumni/Vansika-Pareek.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>VANSIKA PAREEK</h3>
    <p>SOFTWARE ENGINEER</p>
    <p>YEAR OF PASSING: 2015</p>
    <p>CURRENT COMPANY: Amazon GmbH</p>
 

  
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
         <img src='../newimg/alumni/Amogh-Pareek.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>AMOGH PAREEK</h3>
    <p>B.B.A., LL.B (Hons.)</p>
    <p>YEAR OF PASSING: 2017</p>
    <p>COLLEGE: National Law University, Jodhpur</p>
 

  
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
        <img src='../newimg/alumni/Riya-Shekhawat.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>RIYA SHEKHAWAT</h3>
    <p>MBBS</p>
    <p>YEAR OF PASSING: 2017</p>
    <p>COLLEGE: NIMS University, Jaipur</p>
 

  
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
        <img src='../newimg/alumni/Vedant-Goyal.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>VEDANT GOYAL</h3>
    <p>PLACED IN DEUTSCHE INDIA Pvt. Ltd.</p>
    <p>JEE MAINS RANK: 5847</p>
    <p>JEE ADVANCED RANK: 4104</p>
 

  
  </div>
</div>
 
              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
      <img src='../newimg/alumni/Karan-Singh-Nirvana.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>KARAN SINGH NIRVANA</h3>
    <p>MCEME</p>
    <p>YEAR OF PASSING: 2018</p>
    <p>Currently under training in CADET TRAINING WING (MCEME)</p>
 

  
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
     <img src='../newimg/alumni/Sangam.jpeg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>SANGAM MATHURIA</h3>
    <p>LAWYER/ LEGAL OFFICER</p>
    <p>YEAR OF PASSING: 2017</p>
    <p>B.A. LLB Hons</p>
    <p>VELLORE INSTITUTE OF TECHNOLOGY, CHENNAI</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
     <img src='../newimg/alumni/Ayesha-Khan.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>AYESHA KHAN</h3>
    <p>NEET</p>
    <p>YEAR OF PASSING: 2021</p>
    <p>GOVERMENT MEDICAL COLLEGE, MIRAJ, MAHARASHTRA</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
               <img src='../newimg/alumni/Astik-Sharma-scaled.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>
AASTIK SHARMA</h3>
    <p>NEET</p>
    <p>YEAR OF PASSING: 2020</p>
    <p>SMS MEDICAL COLLEGE MBBS BATCH 2021</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
         <img src='../newimg/alumni/Monika-Dhaka-scaled.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>MONIKA DHAKA</h3>
    <p>NEET</p>
    <p>YEAR OF PASSING: 2020</p>
    <p>AIIMS HYDERABAD</p>
    <p>AIR - 7196 (NEET 2022)</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
           <img src='../newimg/alumni/Mohit-Pareek-scaled.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>MOHIT PAREEK</h3>
    <p>NEET</p>
    <p>YEAR OF PASSING: 2020</p>
    <p>COLLEGE SKGMC SIKAR

MBBS BATCH: 2022</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
          <img src='../newimg/alumni/Lav-Kumawat.png'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>lav kumawat</h3>
    <p>NEET</p>
    <p>YEAR OF PASSING: 2022</p>
    <p>AIIMS JODHPUR</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
           <img src='../newimg/alumni/Ayushay-Joshi.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>AYUSHYA JOSHI</h3>
    <p>IIT</p>
    <p>YEAR OF PASSING: 2022</p>
    <p>IIT - DELHI</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
                     <img src='../newimg/alumni/Aditya-Gaur.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>ADITYA GAUR</h3>
    <p>IIT</p>
    <p>YEAR OF PASSING: 2022 IIT BOMBAY </p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
        <img src='../newimg/alumni/Sneha-Dhaka.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>SNEHA DHAKA</h3>
    <p>IIT</p>
    <p>YEAR OF PASSING: 2022 IIT - DELHI</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
        <img src='../newimg/alumni/Dhruvraj-singh.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>DHRUV RAJ SINGH RATHORE</h3>
    <p>IIT</p>
    <p>YEAR OF PASSING: 2022 IIT KHARAGPUR</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
                  <img src='../newimg/alumni/shivam-agarwal.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>
SHIVAM AGARWAL</h3>
    <p>IIT</p>
    <p>YEAR OF PASSING: 2022

IIT - MANDI</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
      <img src='../newimg/alumni/Purab-Gupta.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>
PURAB GUPTA</h3>
    <p>IIT</p>
    <p>YEAR OF PASSING: 2022

IIT ROPAR (ROOPNAGAR)</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
       <img src='../newimg/alumni/Atishay-Patni-Passport.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>ATISHAY PATNI</h3>
    <p>IIT</p>
    <p>YEAR OF PASSING: 2022

IIT - ROORKEE</p>
  </div>
</div>


              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
       <img src='../newimg/alumni/Aditiya-Joshi.jpg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>ADITYA JOSHI</h3>
    <p>IIT</p>
    <p>YEAR OF PASSING: 2022

BITS PILANI</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
    <img src='../newimg/alumni/APOHAN.png'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>APOHAN PAREEK</h3>
    <p>CLAT</p>
    <p>YEAR OF PASSING: 2022</p>
    <p>AIR – 33</p>
    <p>NATIONAL LAW UNIVERSITY, DELHI</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
    <img src='../newimg/alumni/MASHA.png'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>MASHA JANDU</h3>
    <p>CLAT</p>
    <p>YEAR OF PASSING: 2022</p>
    <p>AIR – 798</p>
    <p>CONSORTIUM OF NATIONAL LAW UNIVERSITIES, BENGALURU</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
         <img src='../newimg/alumni/Puranjay-Singh-Nirwan.jpeg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>Puranjay Singh Nirwan</h3>
    <p>NDA</p>
    <p>YEAR OF PASSING: 2022</p>
    <p>AIR – 22</p>
    <p>NATIONAL DEFENCE ACADEMY</p>
  </div>
</div>

              <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
           <img src='../newimg/alumni/Himanshu-Sevaria.jpeg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>Himanshu Sevaria</h3>
    <p>NDA</p>
    <p>NEET</p>
    <p>AIR – 22</p>
    <p>YEAR OF PASSING: 2020 GMC, CHITTORGARH</p>
  </div>
</div>


  <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
  <img src='../newimg/alumni/Abhishek-Kumar-Choudhary.jpeg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>DR. Abhishek Kumar Choudhary</h3>
    <p>YEAR OF PASSING: 2011 MD PHARMACOLOGY</p>
    <p>(SMS MEDICAL COLLAGE AND ATTACHED HOSPITAL)</p>
  </div>
</div>

  <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
 <img src='../newimg/alumni/Anirudh-Gupta.jpeg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>CA. Anirudh Gupta</h3>
    <p>YEAR OF PASSING: 2015

IIM Ahmedabad</p>
  </div>
</div>

  <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
  <img src='../newimg/alumni/Kshitij-Jain.jpeg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>Kshitij Jain</h3>
    <p>YEAR OF PASSING: 2020

Oxford University, UK</p>
  </div>
</div>


    <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
   <img src='../newimg/alumni/Nabhanyu-Sharma-.jpeg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>Nabhanyu Sharma</h3>
    <p>YEAR OF PASSING: 2010 BSc Geology,</p>
    <p>BSc Geology,</p>
    <p>Somaiya College, Mumbai</p>
    <p>School teacher, languages
Japan</p>
  </div>
</div>

    <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
  <img src='../newimg/alumni/Tanyut-Sharma.jpeg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>
Tanyut Sharma</h3>
    <p>YEAR OF PASSING: 2018</p>
    <p>IT Bombay Grad.(B.Tech)</p>
    <p>Research Scientist
Siemens Bangalore,</p>
    <p>Robotics R&D division</p>
  </div>
</div>

    <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
<img src='../newimg/alumni/Shubham-Agarwal.jpeg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>Shubham Agarwal</h3>
    <p>YEAR OF PASSING: 2015</p>
    <p>UPSE Assistant Commandant 2022,</p>
    <p>JRF in Psychology,</p>
    <p>UPSC CSE 2023 Rank 599.</p>
  </div>
</div>

    <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
       <img src='../newimg/alumni/Arya-Choudhary.jpeg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>
Arya choudhary</h3>
    <p>YEAR OF PASSING: 2022</p>
    <p>Bayes Business School, London

B. Sc. Hons with Marketing</p>
  
  </div>
</div>

    <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
   <img src='../newimg/alumni/siddharth.jpeg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
    <h3>Siddharth Biswas</h3>
    <p>YEAR OF PASSING: 2019</p>
    <p>MMUS, Music with Distinction</p>
    <p>Royal Holloway University of London</p>
  
  </div>
</div>

    <div className='uni-placements'>
  <div className='uni-placemet-img'>
    <Link to="">
           <img src='../newimg/alumni/anushka.jpeg'/>
    </Link>
  </div>
  <div className='uni-placement-content'>
  <h2>Anushka Choudhary</h2>
    <p>YEAR OF PASSING: 2019</p>
    <p>Masters in Design </p>
    <p>NID Ahmedabad</p>
  
  </div>
</div>





     

        </div>
         
        {/* 2. AlumniGuiding*/}
        <div style={{ marginTop: '40px' }}>
             <AlumniGuiding />
        </div>
      </div>


      
    </div>
     
 
      )
    }

    export default Alumni;
